import { React } from 'react';
import { Link } from 'react-router-dom';

const MockupReport = () => {
    return (
            <div>
                <div className="connection-header">
                    <h3>Mockup</h3>
                    <div className="filter-wrapper">
                        <div className="list-filter">
                            <i className="ri-equalizer-line"></i>
                            <span>Filter</span>
                        </div>
                        <Link to="/business/single/mockup/new" className="list-filter add-new-btn">
                            <i className="ri-add-line"></i>
                            <span>Add New</span>
                        </Link>
                    </div>
                </div>
                <div className="card-container card-report-area card-grid-3">
                    {/* Total Connects */}
                    <div className="card-widget total-connects">
                        <h5 className="widget-value">705</h5>
                        <span className="widget-title">Connects</span>
                        <i className="ri-group-fill"></i>
                    </div>
                    {/* Total view */}
                    <div className="card-widget total-view">
                        <h5 className="widget-value">643</h5>
                        <span className="widget-title">Total View</span>
                        <i className="ri-eye-fill"></i>
                    </div>
                    {/* Total view 2 */}
                    <div className="card-widget total-viewed text-white">
                        <h5 className="widget-value">643</h5>
                        <span className="widget-title">Total View</span>
                        <i className="ri-eye-fill"></i>
                    </div>
                </div>
            </div>
    );
}

export default MockupReport;